// extracted by mini-css-extract-plugin
export default {"activityRow":"styles_activityRow__KojCP","firstColumn":"styles_firstColumn__zXX-g"};